<template>
  <v-card-text v-if="!disabled && loading">
    <app-spinner />
  </v-card-text>
  <v-form v-else ref="loginForm" v-model="valid">
    <v-text-field
      ref="emailField"
      v-model="email"
      :rules="emailRules"
      :validate-on-blur="true"
      placeholder="Type your e-mail here"
      required
      :disabled="disabled"
      @keypress.enter.prevent="doEmailLogin"
    />

    <v-btn large color="primary" block rounded class="mt-1" :disabled="disabled" @click="doEmailLogin">LOGIN</v-btn>
  </v-form>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '@/services'
import validationRules from '@/utils/validation'

export default Vue.extend({
  name: 'EmailLoginFrom',
  props: {
    onboardSource: {
      type: String,
      default: 'Unknown',
    },
    disabled: Boolean,
  },

  data: () => ({
    email: '',
    valid: false,
    loading: false,
    emailRules: validationRules.emailRules,
  }),
  methods: {
    doEmailLogin: function () {
      if (this.$refs.loginForm && !this.$refs.loginForm.validate()) {
        this.$refs.emailField.blur()
        return
      }
      this.loading = true
      this.$emit('login-email-requested-started')

      ApiService.post(`auth/email`, {
        email: this.email,
        redirect: this.$router.currentRoute.query.redirect,
        onboard_source: this.onboardSource,
      }).then((response) => {
        this.loading = false
        this.$emit('login-request-complete')
      })
    },
  },
})
</script>
